import type { InboxThread } from "@tellescope/types-models";
import { cn } from "@tellescope/utils";

export interface ChannelColorConfig {
  backgroundColor: string;
  iconColor: string;
  borderColor: string;
  name: string;
}

export const CHANNEL_COLORS: Record<InboxThread["type"], ChannelColorConfig> = {
  Chat: {
    backgroundColor: cn("bg-blue-50"),
    iconColor: cn("text-blue-600"),
    borderColor: cn("border-blue-200"),
    name: "Chat",
  },
  Email: {
    backgroundColor: cn("bg-purple-50"),
    iconColor: cn("text-purple-600"),
    borderColor: cn("border-purple-200"),
    name: "Email",
  },
  SMS: {
    backgroundColor: cn("bg-green-50"),
    iconColor: cn("text-green-600"),
    borderColor: cn("border-green-200"),
    name: "SMS",
  },
  GroupMMS: {
    backgroundColor: cn("bg-teal-50"),
    iconColor: cn("text-teal-600"),
    borderColor: cn("border-teal-200"),
    name: "Group MMS",
  },
  Phone: {
    backgroundColor: cn("bg-orange-50"),
    iconColor: cn("text-orange-600"),
    borderColor: cn("border-orange-200"),
    name: "Phone",
  },
  Zendesk: {
    backgroundColor: cn("bg-gray-100"),
    iconColor: cn("text-gray-800"),
    borderColor: cn("border-gray-300"),
    name: "Zendesk",
  },
};

export const getChannelColor = (channel: InboxThread["type"]): ChannelColorConfig => {
  return CHANNEL_COLORS[channel];
};
